import { ccApi } from "./ccApi";

/* Part 7 — client-side evidence capture. Grabs the current frame of the
 * most relevant <video> (Live) or the page's media <img>, paints it on a
 * canvas with a timestamp/ID watermark, uploads it as PNG. DOM-only pages
 * without media fall back to a text card so the record still exists. */
export async function captureFrame({ selectorHint, label }) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  let source = null;
  const videos = Array.from(document.querySelectorAll("video")).filter((v) => v.videoWidth > 0 && !v.paused);
  if (videos.length) source = videos.sort((a, b) => b.videoWidth * b.videoHeight - a.videoWidth * a.videoHeight)[0];
  if (!source && selectorHint) {
    const scope = document.querySelector(selectorHint);
    const img = scope?.querySelector("img[src*='/api/files/'], video");
    if (img && (img.naturalWidth || img.videoWidth)) source = img;
  }
  if (source) {
    canvas.width = source.videoWidth || source.naturalWidth;
    canvas.height = source.videoHeight || source.naturalHeight;
    try {
      ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
    } catch (_) {
      source = null;
    }
  }
  if (!source) {
    canvas.width = 1280; canvas.height = 720;
    ctx.fillStyle = "#09090b"; ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#fff"; ctx.font = "28px sans-serif";
    ctx.fillText("No capturable media frame on this view", 40, 120);
    ctx.font = "22px monospace";
    ctx.fillText(window.location.href.slice(0, 90), 40, 180);
  }
  const stamp = `${new Date().toISOString()} · ${label || ""} · ${window.location.pathname}`;
  ctx.font = `${Math.max(14, Math.round(canvas.width / 60))}px monospace`;
  ctx.fillStyle = "rgba(0,0,0,0.6)"; ctx.fillRect(0, canvas.height - 40, canvas.width, 40);
  ctx.fillStyle = "#fff"; ctx.fillText(stamp, 12, canvas.height - 14);
  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  return { blob, hadMedia: !!source };
}

export async function captureAndUpload({ target, reasonCode, caseId, note, selectorHint }) {
  const { blob, hadMedia } = await captureFrame({ selectorHint, label: `${target.type}:${target.id}` });
  const data = await ccApi.uploadScreenshot(blob, {
    target_type: target.type, target_id: target.id, account_id: target.accountId || "",
    reason_code: reasonCode, case_id: caseId || "", note: `${note || ""}${hadMedia ? "" : " [no media frame — DOM card]"}`.trim(),
  });
  return { ...data, hadMedia };
}
